<template>
  <div class="Drops-filters">
    <!-- <WrldTextFieldFilters :wrld="{index: 'Quotes', pageSize: 20}" /> -->
    <!-- <WrldCurrentFilters /> -->
    <WrldSelectableFilters :wrld="{index: 'Quotes', pageSize: 20}" :arrFilters="WrldSelectablearrFilters" />
  </div>
</template>

<script>
// import WrldCurrentFilters from '@/components/wrld/filters/WrldCurrentFilters'
import WrldSelectableFilters from '@/components/wrld/filters/WrldSelectableFilters'
// import WrldTextFieldFilters from '@/components/wrld/filters/WrldTextFieldFilters'

export default {
  name: 'ShipmentsQuoteFilters',
  components: {
    WrldSelectableFilters
    // WrldTextFieldFilters,
    // WrldCurrentFilters
  },
  computed: {
    arrFilters () {
      return [
        // { title: this.$t('companies.reference_number'), attribute: 'refNumber' },
        // { title: this.$t('companies.company_name'), attribute: 'name' },
        // { title: this.$t('locations.address'), attribute: 'location' },
        // { title: this.$t('companies.groups'), attribute: 'groups' },
        // { title: this.$t('companies.labels'), attribute: 'labels' }
      ]
    },
    WrldSelectablearrFilters () {
      return [
        // { title: this.$t('locations.address'), attribute: 'Address' },
        // { title: this.$t('companies.labels'), attribute: 'Labels' },
        // { title: 'Verified', attribute: 'Verified', defaultValues: [{ value: 'True' }, { value: 'False' }], hideNumber: true, isSearchable: false }
      ]
    }
  }
}
</script>
